import ActivityNoteDetails from '../../../components/AssetManagement/ActivityNotes/ActivityNotesTable/ActivityNoteDetails'

const BusinessActivityNotesDetailsScreen = () => {
  return (
    <>
      <ActivityNoteDetails />
    </>
  )
}

export default BusinessActivityNotesDetailsScreen
